import styled from 'styled-components';

export const StackSpace = styled.div`
  height: ${p => p.size}rem;
`;
